/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Auto-open quiz popup 15 seconds after page load ---
  // Fires whether the user browses/clicks around or stays idle.
  // Only exception: if they click the quiz menu option directly,
  // the auto-timer is cancelled since the quiz is already open.
  const QUIZ_AUTO_DELAY_MS = 15000; // 15 seconds
  const SESSION_KEY = 'babyfoonQuizAutoShown';

  let autoQuizTimer = null;

  function maybeAutoOpenQuiz() {
    // Already shown once this session? Don't show again.
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const quizPopup = document.getElementById('custom-quiz-popup');
    if (!quizPopup) return;

    // Already open (user triggered it manually)? Don't override.
    if (quizPopup.style.display === 'flex') return;

    if (typeof window.openQuizPopup === 'function') {
      window.openQuizPopup();
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
  }

 function isQuizMenuClick(target) {
    // Walk up from the clicked element to see if it (or an ancestor)
    // is the quiz nav trigger link/button (identified by its label text).
    let el = target;
    while (el && el !== document.body) {
      if (el.textContent && el.textContent.trim().toLowerCase() === 'keuzehulp') return true;
      el = el.parentElement;
    }
    return false;
  }

  function cancelAutoQuizTimerIfMenuClicked(event) {
    if (isQuizMenuClick(event.target) && autoQuizTimer) {
      clearTimeout(autoQuizTimer);
      autoQuizTimer = null;
      // Mark as shown so it doesn't try to auto-open later on
      // another page view within the same session.
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
  }

  // Start the countdown immediately on page load.
  autoQuizTimer = setTimeout(maybeAutoOpenQuiz, QUIZ_AUTO_DELAY_MS);

  // Listen (capture phase) for a click on the quiz menu option,
  // so we can cancel the pending auto-popup if it happens first.
  document.addEventListener('click', cancelAutoQuizTimerIfMenuClicked, true);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  // --- Style the quiz menu option as a badge/pill ---
  function styleQuizNavTrigger() {
    const allLinks = document.querySelectorAll('a, button');
    allLinks.forEach(function(el) {
      if (el.dataset.quizStyled) return;
      const text = el.textContent.trim().toLowerCase();
      if (text === 'keuzehulp') {
        el.dataset.quizStyled = 'true';
        el.classList.add('quiz-nav-badge');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', styleQuizNavTrigger);
  document.addEventListener('theme:drawer:open', function() {
    setTimeout(styleQuizNavTrigger, 150);
  });
  document.addEventListener('theme:sliderule:open', function() {
    setTimeout(styleQuizNavTrigger, 150);
  });

  // --- Inject badge CSS for the quiz nav trigger ---
  const quizBadgeStyle = document.createElement('style');
  quizBadgeStyle.textContent = `
    .quiz-nav-badge {
      background: #F39E5F !important;
      color: #fff !important;
      padding: 6px 16px !important;
      border-radius: 50px !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      white-space: nowrap !important;
      transition: background 0.2s ease, transform 0.2s ease;
      display: inline-flex !important;
      align-items: center !important;
    }
    .quiz-nav-badge:hover {
      background: #e08d4e !important;
      transform: scale(1.03);
      color: #fff !important;
    }
  `;
  document.head.appendChild(quizBadgeStyle);

})();